import { appSliceName } from '../app/constants';
import { appReducer } from '../app/slice';

export const rootReducer = {
  [appSliceName]: appReducer
};
